import { TVerificationPageV2 } from '@/config/types'
import { PageName } from '@/enums/pageName'
import { getPath } from '@/utils/urlUtils'

import i18n from './../../i18n'

export const verificationPage: TVerificationPageV2 = {
  pageTitle: i18n.t('verificationPage.pageTitle'),

  codeTitle: i18n.t('verificationPage.codeTitle'),
  codeFormDescription: (email: string) =>
    `${i18n.t('verificationPage.codeFormDescription', { email: email })}`,
  codePlaceholder: '000000',
  codeButtonName: i18n.t('verificationPage.codeButtonName'),

  emailTitle: i18n.t('verificationPage.emailTitle'),
  emailFormDescription: i18n.t('verificationPage.emailFormDescription'),
  emailPlaceholder: i18n.t('verificationPage.emailPlaceholder'),
  emailButtonName: i18n.t('verificationPage.emailButtonName'),

  nextUrl: getPath(PageName.paymentSuccess),

  contactsText: i18n.t('verificationPage.contactsText'),
  resendButtonText: i18n.t('verificationPage.resendButtonText'),
  resendCooldownText: i18n.t('verificationPage.resendCooldownText'),
  backButtonCaption: i18n.t('verificationPage.backButtonCaption'),
}
